import CN from "./cn";
import EN from "./en";
const LanguageTypes = ["CN", "EN"];
var stdin_default = {
  CN,
  EN
};
export {
  LanguageTypes,
  stdin_default as default
};
